import router from '@/router'
import { useUserStoreHook } from '@/store/user'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false }) // 进度条
const whiteList = ['/login', '/404', '/phone', '/forget_password', 'lucky_draw', '/lucky', '/lucky2','/privacy','/agreement']

router.beforeEach((to, from, next) => {
  NProgress.start()

  const screenWidth = window.innerWidth
  console.log('打印screenWidth==', screenWidth)
  if (to.path == '/phone' || to.path == 'privacy' || to.path == 'agreement') {
    next()
  }
  if (screenWidth < 200) {
    next({ path: '/phone' })
  } else {
    const hasToken = localStorage.getItem('token_blk')
    if (hasToken) {
      if (to.path === '/login') {
        next({ path: '/' })
        NProgress.done()
      } else {
        const userStore = useUserStoreHook()
        const hasRoutes = userStore.routes && userStore.routes.length > 0
        if (hasRoutes) {
          if (to.path == '/email' && !userStore.info.email) {
            ElMessage({
              type: 'warning',
              message: '没有绑定邮箱，请联系管理员!'
            })
            next({ path: '/' })
            NProgress.done()
          }

          if (from.path.search('/product_display/product_detail') != -1 && to.path == '/product_display') {
            next(from.path)
          }
          if (to.matched.length == 0) {
            from.name ? next() : next('/404')
          } else {
            next()
          }
        } else {
          // 获取用户信息
          userStore.getInfo().then(res => {
            next()
          })
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})
